module.exports = __webpack_public_path__ + "img/power-op-curve2.74915a57.png";